import { usePrivy } from '@privy-io/react-auth';
import Button from '../../../ButtonCustom';
import {PeopleListIcon} from '../../../svgComponents/PeopleListIcon.jsx';

import { useAppStore } from '../../../../store/appStore';
import { useContextProvider } from '../../../../context';
import { sanitizeMaxDecimals } from '../../../../utils/formatNumber.js';
import { useTokensStore } from '../../../../store/tokensStore.js';
import { formatDollarAmount } from '../../../../utils/formatDollarAmount.js';
import { Loader } from '../../../Loader/index.jsx';

export const ConnectWalletButton = () => {
  const { authenticated, ready } = usePrivy();
  const { setIsOpenedUserMenu, setMenuActive } = useAppStore();
  const { login } = useContextProvider();
  const { userTokens } = useTokensStore();

  const handleClick = () => {
    if (authenticated) {
      setMenuActive(false);

      setIsOpenedUserMenu(true);
    } else {
      login();
    }
  };

  return (
    <Button
      variant="filled"
      className="gap-2 disabled:opacity-70 !h-[36px] font-[600] sm:!h-[45px] min-w-[169px]
       sm:min-w-[180px] justify-between"
      onClick={handleClick}
      disabled={!ready}
    >
      <>
        {authenticated ? (
          <>
            {userTokens.length ? (
              <>
                <div className="w-full">
                  <span>
                    {formatDollarAmount(
                      sanitizeMaxDecimals(userTokens[0].valueInUsdt || 0),
                      2,
                      2,
                      ' '
                    ) || '0'}
                  </span>{' '}
                  <span>{userTokens[0].symbol}</span>
                </div>
              </>
            ) : (
              <div className="w-full flex justify-center items-center">
                <Loader fill="#fff" ratio={24} />
              </div>
            )}
            <div className="">
              <PeopleListIcon />
            </div>
          </>
        ) : (
          <span className="text-center w-full">Connect Wallet</span>
        )}
      </>
    </Button>
  );
};
